<template>
  <div class="container">
    <div class="mt-2 card">
      <PatientInfo v-if="patient_id" :patient_id="patient_id">
        <template v-slot:action-bt>
          <button
            v-if="admission_status === 'not_admitted'"
            @click="show_request_admit"
            class="mycustom-success-button"
          >
            Request Admission
          </button>
        </template>
      </PatientInfo>
    </div>
  </div>

  <div class="container">
    <div class="mt-2 card">
      <table class="table align-items-center mb-0">
        <thead>
          <tr style="color: black">
            <th scope="col">Patient Status:</th>
            <th scope="col">{{ formattedStatus }}</th>
          </tr>
        </thead>
      </table>
    </div>
  </div>

  <!-- Bed details only if admitted -->
  <div v-if="admission_status === 'admitted_assigned'" class="container mt-3">
    <div class="card">
      <h5 class="p-2">Admission Details</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Ward</th>
            <th>Ward Type</th>
            <th>Bed</th>
            <th>Admission Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ admission_details.ward }}</td>
            <td>{{ admission_details.ward_type }}</td>
            <td>{{ admission_details.bed }}</td>
            <td>{{ admission_details.admission_date }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <RequestAdmissionModal
    v-if="show_request_admission_modal"
    :visit_id="visit_id"
    @close-request-admission-modal="close_request_admit"
  />
</template>

<script>
import PatientInfo from "../Patients/components/patient_biodata.vue";
import { generalApiRequest } from "../../api/apiIndex";

import RequestAdmissionModal from "./inpatient/request_admission_modal.vue";

export default {
  name: "VisitsDashboard",
  data() {
    return {
      show_add_lab_test_modal: false,
      visit_id: this.$route.params.visitid,
      patient_id: null,
      admission_status: "loading",
      admission_details: {},
      show_request_admission_modal: false,
    };
  },
  components: { PatientInfo, RequestAdmissionModal },
  computed: {
    formattedStatus() {
      if (this.admission_status === "loading") {
        return "Loading...";
      }
      if (this.admission_status === "not_admitted") {
        return "Not Admitted";
      }
      if (this.admission_status === "awaiting_bed") {
        return "Admitted - Awaiting Bed Assignment";
      }
      if (this.admission_status === "admitted_assigned") {
        return "Admitted - Bed Assigned";
      }
      return "Unknown";
    },
  },

  methods: {
    show_request_admit() {
      this.show_request_admission_modal = true;
    },
    close_request_admit() {
      this.show_request_admission_modal = false;
      this.get_admission_status();
    },
    async get_patient_id_from_visit() {
      const res = await generalApiRequest(
        "get_patient_id_from_visit",
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.patient_id = res.data;
      this.get_admission_status();
    },

    async get_admission_status() {
      try {
        const res = await generalApiRequest(
          "getVisitById/" + this.visit_id,
          "GET",
          {},
          1
        );

        // Determine admission status
        if (
          res.is_inpatient === 0 ||
          res.is_inpatient === "0" ||
          res.is_inpatient === null
        ) {
          this.admission_status = "not_admitted";
        } else {
          if (res.bed_id === null || res.bed_id === "0") {
            this.admission_status = "awaiting_bed";
          } else {
            this.admission_status = "admitted_assigned";
          }
        }

        // Store details for display if admitted
        this.admission_details = {
          ward: res.ward,
          ward_type: res.ward_type,
          bed: res.bed_number,
          admission_date: res.start_visit_date,
        };
      } catch (error) {
        console.error("Error fetching admission status:", error);
        this.admission_status = "not_admitted";
      }
    },

    hideCreateTestModel() {
      this.show_add_lab_test_modal = false;
    },
  },

  mounted() {
    this.get_patient_id_from_visit();
  },
};
</script>
